import React from 'react';
import {
  Home as HomeIcon,
  ManageAccounts as ManageIcon,
  Insights as InsightIcon,
} from '@mui/icons-material';
import { RoleBasedConfig } from './routeTypes';
import { UserRole } from '@features/authentication/types';
import { commonNavigationItems, commonRoutes } from './commonRoutes';
import { DashboardRoutes } from '@features/dashboard';
import { ManageRoutes } from '@features/manage';
import { InsightRoutes } from '@features/insight';
import { ProtectedRoute } from '../ProtectedRoute';
import { Navigate } from 'react-router-dom';

export const systemAdminConfig: RoleBasedConfig = {
  navigation: {
    top: [
      {
        label: 'Home',
        href: '/app/dashboard',
        icon: React.createElement(HomeIcon),
      },
      {
        label: 'Manage',
        href: '/app/manage',
        icon: React.createElement(ManageIcon),
      },
      {
        label: 'Insight',
        href: '/app/insight',
        icon: React.createElement(InsightIcon),
      },
    ],
    bottom: commonNavigationItems.bottom,
  },
  routes: [
    {
      path: 'dashboard',
      element: React.createElement(ProtectedRoute, null, React.createElement(DashboardRoutes)),
      protected: true,
      requiredRoles: [UserRole.SYSTEM_ADMIN],
    },
    {
      path: '',
      element: React.createElement(Navigate, { to: 'dashboard', replace: true }),
    },
    {
      path: 'manage/*',
      element: React.createElement(ProtectedRoute, null, React.createElement(ManageRoutes)),
      protected: true,
      requiredRoles: [UserRole.SYSTEM_ADMIN],
    },
    {
      path: 'insight/*',
      element: React.createElement(ProtectedRoute, null, React.createElement(InsightRoutes)),
      protected: true,
      requiredRoles: [UserRole.SYSTEM_ADMIN],
    },
    ...commonRoutes,
  ],
};
